export const CHART_CATEGORIES = [
  "financial",
  "valuation",
  "growth",
  "profitability",
] as const;

export const CHART_SLUGS = [
  // financial
  "revenue-breakdown",
  "EPS",
  "diluted-EPS",
  "revenue",
  "operating-income",
  "net-income",
  "operating-expenses",
  "cash-flow",
  "cash-and-debt",

  // valuation
  "pe-ratio",
  "ps-ratio",
  "pb-ratio",
  "forward-pe",
  "ev-ebitda",
  "ev-sales",
  "pe-ratio-river",

  // growth
  "peg-ratio",
  "eps-surprise-ratio",
  "revenue-surprise-ratio",

  // profitability
  "roe-roa",
  "ros",
  "profitability-ratios",
] as const;

export const CHART_IDS = [
  // financial
  "revenue-breakdown-chart",
  "eps-chart",
  "eps-diluted-chart",
  "revenue-chart",
  "operation-income-chart",
  "net-income-chart",
  "operating-expenses-chart",
  "cash-flow-chart",
  "cash-and-debt-chart",

  // valuation
  "pe-ratio-chart",
  "ps-ratio-chart",
  "pb-ratio-chart",
  "forward-pe-chart",
  "ev-to-ebitda-chart",
  "ev-to-sales-chart",
  "pe-stream-chart",

  // growth
  "peg-ratio-chart",
  "eps-surprise-chart",
  "revenue-surprise-chart",

  // profitability
  "operating-roa-chart",
  "ros-chart",
  "profit-margin-chart",
] as const;

export type ChartCategory = (typeof CHART_CATEGORIES)[number];
export type ChartSlug = (typeof CHART_SLUGS)[number];
export type ChartId = (typeof CHART_IDS)[number];
